import { render, staticRenderFns } from "./templeteManage.vue?vue&type=template&id=e24a1642"
import script from "./templeteManage.vue?vue&type=script&lang=js"
export * from "./templeteManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports